import React from 'react';

import { RecipientGroupsProps } from '../../../../../types/globalSetting';
import RecipientGroupAddOrEditModal from '../CustomerRecipientGroupModal';
import { DefaultGroupModal } from '../EditDefaultGroupModal';
const RecipientGroupEditModal = (props: {
  data: RecipientGroupsProps | undefined;
  onClose: () => void;
  loadAllRecipientGroups: () => void;
  visible: boolean;
  withEditPermission: boolean;
}) => {
  if (!props.data) return null;

  return props.data.isDefault ? (
    <DefaultGroupModal
      data={props.data}
      loadAllRecipientGroups={props.loadAllRecipientGroups}
      onClose={props.onClose}
      visible={props.visible && props.data.isDefault}
      withEditPermission={props.withEditPermission}
    />
  ) : (
    <RecipientGroupAddOrEditModal
      loadAllRecipientGroups={props.loadAllRecipientGroups}
      data={props.data}
      onClose={props.onClose}
      withEditPermission={props.withEditPermission}
      visible={props.visible && !props.data.isDefault}
    />
  );
};

export default React.memo(RecipientGroupEditModal);
